<template>
    <div class="talentPeople">
        <div class="banner"></div>
        <div class="xiangqing">
            <div class="xiangqing-all-info" @click="clickJumpBoss">
                <p>BOSS直聘—南京壹宝通信息技术有限公司</p>
                <div class="xiangqing-main">
                    <div class="left-box">
                        <img src="./imgs/img-bosszhipin.webp" alt="">
                    </div>
                    <div class="right-box">
                        <div class="info-box">南京壹宝通信息技术有限公司详情招聘信息,新岗位上线实时通知，求职快人一步!</div>
                    </div>
                    <span class="span-detail">详情</span>
                </div>
            </div>
        </div>
        <!-- <ul class="zhaopin">
            <li @click="jumpJL">
                <p class="name-zhaopin">
                    <span class="span1">软件项目经理</span>
                    <img src="http://dfs.yun300.cn/group1/M00/15/0A/rBQBG1x2K7OEHXgQAAAAANXeBW0116.png" alt="">
                    <span class="span2">10000-15000</span>
                </p>
                <p class="info-zhaopin">
                    <span class="span1">全职&nbsp;&nbsp;/&nbsp;&nbsp;3-5年&nbsp;&nbsp;/&nbsp;&nbsp;本科</span>
                    <span class="span2">江苏省 - 南京市 - 建邺区</span>
                </p>
            </li>
            <li @click="jumpJAVA">
                <p class="name-zhaopin">
                    <span class="span1">JAVA开发工程师</span>
                    <img src="http://dfs.yun300.cn/group1/M00/15/0A/rBQBG1x2K7OEHXgQAAAAANXeBW0116.png" alt="">
                    <span class="span2">7000-9000</span>
                </p>
                <p class="info-zhaopin">
                    <span class="span1">全职&nbsp;&nbsp;/&nbsp;&nbsp;1-3年&nbsp;&nbsp;/&nbsp;&nbsp;本科</span>
                    <span class="span2">江苏省 - 南京市 - 建邺区</span>
                </p>
            </li>
            <li @click="jumpXS">
                <p class="name-zhaopin">
                    <span class="span1">阿里巴巴旗下钉钉软件销售</span>
                    <img src="http://dfs.yun300.cn/group1/M00/15/0A/rBQBG1x2K7OEHXgQAAAAANXeBW0116.png" alt="">
                    <span class="span2">7000-12000</span>
                </p>
                <p class="info-zhaopin">
                    <span class="span1">全职&nbsp;&nbsp;/&nbsp;&nbsp;不限&nbsp;&nbsp;/&nbsp;&nbsp;本科</span>
                    <span class="span2">江苏省 - 南京市 - 建邺区</span>
                </p>
            </li>
            <li @click="jumpQD">
                <p class="name-zhaopin">
                    <span class="span1">前端低代码开发实习生</span>
                    <img src="http://dfs.yun300.cn/group1/M00/15/0A/rBQBG1x2K7OEHXgQAAAAANXeBW0116.png" alt="">
                    <span class="span2">3000-5000</span>
                </p>
                <p class="info-zhaopin">
                    <span class="span1">实习&nbsp;&nbsp;/&nbsp;&nbsp;不限&nbsp;&nbsp;/&nbsp;&nbsp;专科</span>
                    <span class="span2">江苏省 - 南京市 - 建邺区</span>
                </p>
            </li>
        </ul> -->
        <!-- <div class="xiangqing-box">招聘详情 — <span class="span-zhaopon" @click="clickJumpBoss">boss招聘</span></div> -->
    </div>
</template>
        
<script>
export default {
    
   methods: {
       jumpJL(){
           this.$router.push({name:"zhaopinJiangli"})
       },
       jumpJAVA(){
           this.$router.push({name:"JavaKaifa"})
       },
       jumpXS(){
           this.$router.push({name:"dingdingxiaoshou"})
       },
       jumpQD(){
           this.$router.push({name:"qianduanKaifa"})
       },
       clickJumpBoss(){
        window.open('https://www.zhipin.com/web/geek/job?query=%E5%8D%97%E4%BA%AC%E5%A3%B9%E5%AE%9D%E9%80%9A%E4%BF%A1%E6%81%AF%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&city=101190100')
       }
   }
}
</script>
<style lang='less' scoped>
.talentPeople{
    width: 100%;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/rczp_1920337.5@1x-tuya.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }  
    .xiangqing{
        width: 100%;
        padding: 200px;
        background-color: rgba(245, 245, 245, 1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .xiangqing-all-info{
            width: 30%;
            background-color: #fff;
            padding: 30px;
            padding-right: 15px;
            padding-bottom: 20px;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.2s linear;
        }
        .xiangqing-all-info:hover{
            box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 1px;
        }
        p{
            font-size: 26px;
            color: #000;
            letter-spacing: 1px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .xiangqing-main{
            padding-top: 10px;
            display: flex;
            position: relative;
            .left-box{
                padding: 15px;
                padding-left: 0px;
                img{
                    width: 200px;
                    height: 120px;
                    border-radius: 10px;
                }
            }
            .right-box{
                display: flex;
                padding: 15px;
                .info-box{
                    width: 100%;
                    height: 100%;
                    text-align: left;
                    font-size: 21px;
                    letter-spacing: 0.7px;
                }
            }   
            .span-detail{
                position: absolute;
                font-size: 18px;
                color: #18c3b1;
                right: 34px;
                bottom: 0;
                letter-spacing: 1px;
            }
        }
        
    }
    .zhaopin{
        width: 66%;
        margin: 50px auto;
        li{
            width: 100%;
            height:140px ;
            padding: 35px;
            border: 1px solid #eaecee;
            margin-bottom: 30px;
            cursor: pointer;
            .name-zhaopin{
                height: 30px;
                text-align: left;
                line-height: 30px;
                img{
                    width: 23px;
                    height: 23px;
                    margin-left: 20px;
                    vertical-align: top;
                    margin-top: 3px;
                }
                .span1{
                    font-size: 24px;
                    color: #333;
                    line-height: 30px;
                    max-width: 150px;
                    margin-left: 20px;
                }
                .span2{
                    font-size: 18px;
                    color: #ff5959;
                    float: right;
                }
            }
            .info-zhaopin{
                text-align: left;
                margin-top: 20px;
               .span1{
                    font-size: 14px;
                    color: #999;
                    height: 20px;
                    line-height: 20px;
                    margin-left: 90px;
                }
                .span2{
                    font-size: 14px;
                    color: #999;
                    float: right;
                    margin-right: 90px;
                }
            }
        }
    }
}
.xiangqing-box{
    margin-bottom: 40px;
    letter-spacing: 1.5px;
    .span-zhaopon{
        color: #18c3b1;
        cursor: pointer;
        text-decoration: underline;
    }
}
</style>